// Stable per-member marker colors for the team live map: hash the user id
// into a palette instead of assigning by arrival order (polling reshuffles).
const TEAM_MARKER_COLORS = [
  "#38bdf8",
  "#f472b6",
  "#a3e635",
  "#fbbf24",
  "#c084fc",
  "#fb923c",
  "#2dd4bf",
  "#f87171",
] as const;

function teamMarkerColor(userId: string): string {
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = (hash * 31 + userId.charCodeAt(i)) | 0;
  }
  return TEAM_MARKER_COLORS[Math.abs(hash) % TEAM_MARKER_COLORS.length];
}

export interface TeamMarkerSVGPoint {
  userId: string;
  label: string;
  lat: number;
  lng: number;
  speedKmh?: number | null;
  stale?: boolean;
  /** SVG coordinates — caller projects via convertGPSToSVG. */
  x: number;
  y: number;
}

export default function TeamPositionMarkers({
  markers,
  theme,
  markerStroke,
}: {
  markers: TeamMarkerSVGPoint[];
  theme: "light" | "dark";
  markerStroke: string;
}) {
  return (
    <>
      {markers.map((marker) => {
        const color = teamMarkerColor(marker.userId);
        return (
          <g
            key={marker.userId}
            data-testid={`team-marker-${marker.userId}`}
            opacity={marker.stale ? 0.35 : 1}
          >
            <circle
              cx={marker.x}
              cy={marker.y}
              r="10"
              fill="none"
              stroke={color}
              strokeWidth="2"
              opacity={marker.stale ? 0.3 : 0.6}
            />
            <circle
              cx={marker.x}
              cy={marker.y}
              r="5.5"
              fill={color}
              stroke={markerStroke}
              strokeWidth="2"
            />
            <text
              x={marker.x}
              y={marker.y - 16}
              textAnchor="middle"
              style={{ fontSize: "11px", fontWeight: 600 }}
              fill={theme === "dark" ? "#e2e8f0" : "#1f2937"}
            >
              {marker.label}
              {marker.speedKmh != null
                ? ` · ${Math.round(marker.speedKmh)}km/h`
                : ""}
            </text>
          </g>
        );
      })}
    </>
  );
}
